import React, { useEffect, useRef, useState } from "react";

// IntersectionObserver-based lazy image with skeleton shimmer.
export const LazyImage = ({
  src,
  alt = "",
  className = "",
  wrapperClassName = "",
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    if (!ref.current || visible) return;
    const el = ref.current;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setVisible(true);
            io.disconnect();
          }
        });
      },
      { rootMargin: "200px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [visible]);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden bg-white/40 ${wrapperClassName}`}
    >
      {(!loaded || !visible) && !errored && (
        <div className="absolute inset-0 skeleton-shimmer" />
      )}
      {visible && src && !errored && (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onLoad={() => setLoaded(true)}
          onError={() => setErrored(true)}
          className={`${className} transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
      )}
      {errored && (
        <div className="absolute inset-0 flex items-center justify-center text-xs text-neutral-500">
          image unavailable
        </div>
      )}
    </div>
  );
};
